// HomeCategoryIndex.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { containerVariants, fadeInUp, variants } from '../script/animationVariants';
import { useTranslation } from 'react-i18next';

/* DATA verisi: Her kategori için "name" alanı, 
   hem Türkçe (tr) hem de İngilizce (en) değerlerini içerecek şekilde tanımlanmıştır. */
export const DATA = [
  {
    link: 'sistemler',
    //categorySvg: 'iskele-sistemleri.svg',
    categorySvg: 'sistemler-cover.jpg',
    name: {
      tr: 'SİSTEMLER',
      en: 'SYSTEMS'
    }
  },
  {
    link: 'projeler',
    //categorySvg: 'kalip-sistemleri.svg',
    categorySvg: 'projeler-cover.jpg',
    name: {
      tr: 'PROJELER',
      en: 'PROJECTS'
    }
  }
];

const HomeCategoryIndex = () => {
  // useTranslation hook'u ile mevcut dil değerini alıyoruz.
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Örneğin, 'tr' veya 'en'

  // Hover durumunu yönetmek için state
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className="w-full py-28 bg-white grid grid-cols-14">
      <motion.div initial="hidden"
        animate="visible"
        variants={containerVariants} className="col-start-2 col-span-12  w-full ">
        <motion.h1 variants={fadeInUp(0.2)}
          initial="initial"
          whileInView="animate" className='text-35 md:text-5xl pb-14 font-extralight'>{t('systems-and-projects')}</motion.h1>
      </motion.div>
      <motion.div
        variants={variants.container}
        initial="hidden"
        animate="visible"
        className="col-start-2 col-span-12 grid grid-cols-1 md:grid-cols-2 gap-2"
      >


        {DATA.map((item, index) => (
          <div key={index}>
            {/* Hover animasyonları için motion.div kullanıyoruz */}
            <motion.div
              variants={variants.item}
              whileInView={hoveredIndex === index ? "hover" : "visible"}
              onHoverStart={() => setHoveredIndex(index)}
              onHoverEnd={() => setHoveredIndex(null)}
              className='relative group'
            >
           















              <Link to={item.link &&`/${item.link}`}  key={index} className='relative z-50 block'>
                <motion.div
                           className=' aspect-square pt-10 flex flex-col px-10 group relative'
                           custom={index}
                           whileInView="visible"
                           initial="hidden"
                           variants={variants.list}
                >
                  {/* Üst kısımda ok simgesi */}
                  <div className="h-1/3 w-full flex justify-end">
                    <motion.img
                      src='/images/icons/arrow-white.svg'
                      className='h-1/2 opacity-80 group-hover:opacity-100 '
                      variants={variants.arrow}
                      animate={hoveredIndex === index ? "hover" : "default"}
                      transition={{ duration: 0.3 }}
                      alt="arrow"
                    />
                  </div>
                  {/* Orta kısımda kategori simgesi */}
                  <div className="h-2/3 w-full">
                    <div className="h-1/2">
                      { /*  <motion.img 
                        src={`/images/anasayfa/category/${item.categorySvg}`}
                        className="h-full opacity-50 group-hover:opacity-100 group-hover:scale-105"
                        variants={variants.image}
                        animate={hoveredIndex === index ? "hover" : "default"}
                        transition={{ duration: 0.3 }}
                        alt={item.categoryName1[currentLanguage]}
                      />*/}
                    </div>
                    {/* Alt kısımda kategori ismi: Mevcut dil değerine göre */}
                    <div className='!text-white h-1/2 d flex flex-col justify-center group-hover:opacity-100 transition-all duration-300 text-25 font-thin relative'>
                      <motion.h6
                        // variants={variants.text}
                        // animate={hoveredIndex === index ? "hover" : "default"}
                        transition={{ duration: 0.3 }}
                      >
                        {item.name[currentLanguage]}
                      </motion.h6>
                    </div>
                  </div>

                </motion.div>


              </Link>
              <div className='h-full w-full absolute top-0 left-0  '>
                <img src={`/images/anasayfa/category/${item.categorySvg}`} className='h-full w-full object-cover' />
              </div>
                        <img src='/images/filigran-square.png' className='absolute top-0 left-0 w-full h-full object-cover z-30'/> 
              <div className='h-full w-full bg-black absolute top-0 left-0 opacity-80  group-hover:opacity-0 duration-300 z-40'></div>





















            </motion.div>
          </div>
        ))}

      </motion.div>
    </div>
  );
};

export default HomeCategoryIndex;
